<template>
    <div class="content_right_bottom">
        <div id="content_right_bottom" style="width: 440px;height: 293px;margin-top:30px">
        </div>
        <div class="right_bottom_tips">
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':dimension.color.legal}"></div>
                法律维度
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':dimension.color.econ}"></div>
                经济维度
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':dimension.color.tech}"></div>
                技术维度
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'contentRightBottom',
    props:{
        dimension:{
            type: Object,
			default: () => { }
        }
    },
    mounted() {
        const chartContainer = document.getElementById('content_right_bottom');
        const chart = echarts.init(chartContainer);
        const options = {
            title: {
                text: '价值维度分布图',
                left: 'center',
                top: '0',
                textStyle: {
                    color: '#fff',
                    fontSize: 20,
                    fontWeight: 'bold'
                }
            },
            tooltip: {
				trigger: 'axis', // 坐标轴触发
				formatter: function (params) {
					// 格式化显示内容
					var res = '分值：'+params[0].name + '<br/>';
					params.forEach(function (item) {
						res += `<span style="display:inline-block;margin-right:8px;border-radius:50%;width:8px;height:8px;background-color:${item.color}"></span>`+item.seriesName + ': ' + item.value + '<br/>';
					});
					return res;
				}
			},
            // toolbox: {
            //     feature: {
            //         saveAsImage: {}
            //     }
            // },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                name: '分值',
                nameLocation: 'end',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff'
                    }
                },
                axisLabel: {
                    show: true,
                    color: '#fff'
                },
                data: this.dimension.scoreData
            },
            yAxis: {
                type: 'value',
                name: '数量',
                nameLocation: 'end',
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#fff'
                    }
                },
                axisLabel: {
                    show: false,
                },
                splitArea: {
                    show: true,
                    areaStyle: {
                        color: 'rgba(76, 143, 250, 0.2)'
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        width: '2',
                        color: 'rgba(76, 143, 250, 0.2)'
                    }
                },
            },
            series: [
                {
                    name: '经济维度',
                    type: 'line',
                    stack: 'Total',
                    showSymbol: false,
                    data: this.dimension.econData,
                    color:this.dimension.color.econ,
                    itemStyle: {
						normal: {
							lineStyle: {
								color: this.dimension.color.econ,
								width: 2
							}
						}
					}
                },
                {
                    name: '法律维度',
                    type: 'line',
                    stack: 'Total',
                    color:this.dimension.color.legal,
                    showSymbol: false,
                    data: this.dimension.legalData,
                    itemStyle: {
						normal: {
							lineStyle: {
								color:this.dimension.color.legal,
								width: 2
							}
						}
					}
                },
               {
                    name: '技术维度',
                    type: 'line',
                    stack: 'Total',
                    showSymbol: false,
                    color:this.dimension.color.tech,
                    data: this.dimension.techData,
                    itemStyle: {
						normal: {
							lineStyle: {
								color: this.dimension.color.tech,
								width: 2
							}
						}
					}
                },

            ]
        };
        chart.setOption(options);
    }
}
</script>
<style scoped lang="stylus">
.content_right_bottom{
    position: relative
}
.right_bottom_tips{
    display:flex;
    justify-content:space-between;
    padding: 0 90px;
    position:absolute;
    width:100%;
    bottom:15px;
    box-sizing:border-box;
    color: #FEFEFE;
    font-weight: 400;
    font-size:12.5px;
    .tips_item{
        display:flex;
        align-items:center
    }
    .tips_item_box{
        width: 14px;
        height: 14px;
        border-radius: 4px;
        margin-right:5px
    }
}
</style>


// WEBPACK FOOTER //
// src/views/console/components/contentRightBottom.vue